import React, { useState } from 'react'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import PanelistCard from './PanelistCard'
import collins from '../../../assets/collins 1-min.png'
// Placeholder images - will be replaced with actual panelist photos
import elliot from '../../../assets/elliot-yibaebi.jpeg'
import joshua from '../../../assets/joshua-nwankwo.jpeg'
import udochi from '../../../assets/udochi-kaduru.jpeg'

const Panelists = () => {
  const allPanelists = [
    {
      position: 'Senior Engineering Program Manager Google',
      name: 'Collins Ndukwe',
      imageURL: collins,
      role: 'Moderator',
    },
    {
      position: 'Software Engineer, Appknox',
      name: 'Elliot Yibaebi',
      imageURL: elliot,
      role: 'Panelist',
    },
    {
      position: 'Founding Frontend Engineer, Spheron Protocol',
      name: 'Joshua Nwankwo',
      imageURL: joshua,
      role: 'Panelist',
    },
    {
      position: 'Lead Product Designer, Genesys Tech Hub',
      name: 'Udochi Kaduru',
      imageURL: udochi,
      role: 'Panelist',
    },
  ]

  const panelistsPerPage = Math.min(5, allPanelists.length) // Show all panelists, max 5
  const [displayPanelists, setDisplayPanelists] = useState(allPanelists.slice(0, panelistsPerPage))
  const [startIndex, setStartIndex] = useState(0)

  const handleSwap = direction => {
    let newStartIndex = startIndex

    if (direction === 'left') {
      newStartIndex = (startIndex - 1 + allPanelists.length) % allPanelists.length
    } else if (direction === 'right') {
      newStartIndex = (startIndex + 1) % allPanelists.length
    }

    const newDisplayPanelists = []

    for (let i = 0; i < panelistsPerPage; i++) {
      const index = (newStartIndex + i) % allPanelists.length
      newDisplayPanelists.push(allPanelists[index])
    }

    setStartIndex(newStartIndex)
    setDisplayPanelists(newDisplayPanelists)
  }

  return (
    <div id="panelists" className="px-8 mt-20 relative flex items-center bg-black justify-center">
      <div className="absolute -top-9 lg:top-5">
        <h1 className="text-4xl lg:text-5xl text-white font-bold text-center">Panel Discussion</h1>
        <h2 className="text-xl lg:text-2xl orange font-semibold text-center mt-2">How to Jumpstart Your Tech Career</h2>
        <div className="text-lg text-white mt-6 mb-8 flex flex-col justify-center items-center">
          Meet our panelists
          <div className="flex space-x-2 mt-2 lines">
            <div className="w-56 h-1 rounded-full bg-orange"></div>
            <div className="w-56 h-1 rounded-full bg-white"></div>
          </div>
        </div>
      </div>

      <button
        className="p-3 mt-24 lg:mx-8 hover:bg-bgColor border-2 border-white rounded-full text-white absolute top-0 left-0"
        onClick={() => handleSwap('left')}
      >
        <IoIosArrowBack size={24} />
      </button>

      <div className="flex items-center justify-center -space-x-14" style={{ marginTop: '220px' }}>
        {displayPanelists.map((panelist, index) => (
          <PanelistCard
            key={panelist.name}
            panelist={panelist}
            position={index}
            animationDirection={index === 1 ? 'current' : index < 2 ? 'left' : 'right'}
          />
        ))}
      </div>

      <button
        className="p-3 mt-24 lg:mx-8 hover:bg-bgColor border-2 border-white rounded-full text-white absolute top-0 right-0"
        onClick={() => handleSwap('right')}
      >
        <IoIosArrowForward size={24} />
      </button>
    </div>
  )
}

export default Panelists
